import classNames from 'clsx';
import React from 'react';

import RegularBackground from '../../../assets/tiles/spingo-combined.svg';
import type { GameTypeName, GameTypeUrl } from '../../../types/Game';
import { isTilePromo } from '../../../utils';
import { getBackgroundClasses } from '../../../utils/assets';
import styles from '../shared.scss';

import PromoBackground from './PromoBackground';

export interface BackgroundProps {
  winUpTo: string;
  gameType: GameTypeName;
  isUltra: boolean;
  url: GameTypeUrl;
  promoRef: string;
}

const Background: React.FC<BackgroundProps> = ({ winUpTo, gameType, isUltra, url, promoRef }) => {
  const isPromo = isTilePromo(promoRef, isUltra);
  const backgroundClasses = getBackgroundClasses(url, gameType);

  return (
    <picture className={classNames(styles.bgr, backgroundClasses)}>
      {isPromo ? (
        <PromoBackground promoRef={promoRef} gameType={gameType} winUpTo={winUpTo} />
      ) : (
        <RegularBackground />
      )}
    </picture>
  );
};

export default Background;
